import React from 'react';
import { Modal, Progress } from 'antd';
import { imagePath } from '@common/services/images-service';
import { Colors } from '@common/tokens';

export const FullScreenLoadingBeat = ({
  open,
  description,
  progress,
}: {
  open: boolean;
  description: string;
  progress?: number;
}) => {
  const showProgress = progress !== undefined;

  return (
    <>
      <Modal
        centered
        open={open}
        bodyStyle={{ padding: '0' }}
        maskStyle={{ backgroundColor: Colors.elmHyperlight }}
        footer={null}
        maskClosable={false}
        closable={false}
        className="wk-full-screen-loading-beat"
      >
        <div className="wk-full-screen-loading-beat__body">
          <span className="wk-full-screen-loading-beat__logo">
            <img src={imagePath('./works-logo-elm.svg')} />
          </span>
          <div className="wk-full-screen-loading-beat__beat">
            <img src={imagePath('./loading-beat.gif')} />
          </div>
          {showProgress && (
            <Progress
              strokeColor={Colors.elm}
              status="active"
              percent={progress}
              className="wk-full-screen-loading-beat__progress"
            />
          )}
          <div className="wk-full-screen-loading-beat__description">
            <span>{description}</span>
          </div>
        </div>
      </Modal>
      <style jsx>{`
        :global(.wk-full-screen-loading-beat .ant-modal-content) {
          border: 1px solid ${Colors.elmLightest};
          border-radius: 16px;
          box-shadow: none;
        }

        :global(
          .wk-full-screen-loading-beat
            .wk-full-screen-loading-beat__body
            .wk-full-screen-loading-beat__progress
        ) {
          margin-bottom: 20px;
        }

        :global(.wk-full-screen-loading-beat__body) {
          padding: 44px;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
        }

        :global(.wk-full-screen-loading-beat__logo) {
          position: absolute;
          top: -110px;
        }

        :global(.wk-full-screen-loading-beat__beat) {
          display: flex;
          justify-content: center;
        }

        :global(.wk-full-screen-loading-beat__beat img) {
          width: 210px;
          height: 210px;
        }

        :global(.wk-full-screen-loading-beat__description) {
          display: flex;
          justify-content: center;
        }
      `}</style>
    </>
  );
};
